import { Dispatch } from "redux";
import {
    FormattedIdentityProviderConfiguration,
    IdentityProviderCategory,
    IdentityProviderClassification,
    IdentityProviderCompany,
    IdentityProviderLoa,
    IdentityProviderProtocol
} from "@idw-types/data/identity-providers";
import { setIdentityProviderConfigurations, setIdentityProviderConfigurationsLoading } from "@redux/actions/identity-providers-actions";
import { getIdentityProviderConfigurationsRequest } from "@requests/identity-provider";
import { formatIdentityProviderConfigurations } from "@formatters/identity-providers";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const getIdentityProviderConfigurationsReduxRequest = (dispatch: Dispatch) => async (
    categories: Array<IdentityProviderCategory>,
    classifications: Array<IdentityProviderClassification>,
    companies: Array<IdentityProviderCompany>,
    loas: Array<IdentityProviderLoa>,
    protocols: Array<IdentityProviderProtocol>
): Promise<Array<FormattedIdentityProviderConfiguration>> => {
    dispatch(setIdentityProviderConfigurationsLoading(true));
    const { data, error } = await getIdentityProviderConfigurationsRequest();
    if (data?.identityProviderConfigs) {
        const formattedIdentityProviderConfigurations = formatIdentityProviderConfigurations(
            data.identityProviderConfigs,
            categories,
            classifications,
            companies,
            loas,
            protocols
        );
        dispatch(setIdentityProviderConfigurations(formattedIdentityProviderConfigurations));
        return formattedIdentityProviderConfigurations;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getIdentityProviderConfigurations.error.title,
                resources.requests.getIdentityProviderConfigurations.error.message
            );
        }
        dispatch(setIdentityProviderConfigurationsLoading(false));
        return null;
    }
};